// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/update_vision_location.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/update_vision_location.proto.
 */
export const file_vision_projects_v1_update_vision_location: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vcHJvamVjdHMvdjEvdXBkYXRlX3Zpc2lvbl9sb2NhdGlvbi5wcm90bxIZcHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MSLvAQobVXBkYXRlVmlzaW9uTG9jYXRpb25SZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuVXBkYXRlVmlzaW9uTG9jYXRpb25SZXF1ZXN0LlBhcmFtcxIvCgt1cGRhdGVfbWFzaxgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2saUAoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSEwoLbG9jYXRpb25faWQYAiABKAkSDAoEbmFtZRgDIAEoCRIPCgdhZGRyZXNzGAQgASgJIngKHFVwZGF0ZVZpc2lvbkxvY2F0aW9uUmVzcG9uc2USTgoGcmVzdWx0GAEgASgLMj4ucHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MS5VcGRhdGVWaXNpb25Mb2NhdGlvblJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw", [file_google_protobuf_field_mask]);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionLocationRequest
 */
export type UpdateVisionLocationRequest = Message<"protos.vision.projects.v1.UpdateVisionLocationRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.UpdateVisionLocationRequest.Params params = 1;
   */
  params?: UpdateVisionLocationRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionLocationRequest.
 * Use `create(UpdateVisionLocationRequestSchema)` to create a new message.
 */
export const UpdateVisionLocationRequestSchema: GenMessage<UpdateVisionLocationRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_location, 0);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionLocationRequest.Params
 */
export type UpdateVisionLocationRequest_Params = Message<"protos.vision.projects.v1.UpdateVisionLocationRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string address = 4;
   */
  address: string;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionLocationRequest.Params.
 * Use `create(UpdateVisionLocationRequest_ParamsSchema)` to create a new message.
 */
export const UpdateVisionLocationRequest_ParamsSchema: GenMessage<UpdateVisionLocationRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_location, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionLocationResponse
 */
export type UpdateVisionLocationResponse = Message<"protos.vision.projects.v1.UpdateVisionLocationResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.UpdateVisionLocationResponse.Result result = 1;
   */
  result?: UpdateVisionLocationResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionLocationResponse.
 * Use `create(UpdateVisionLocationResponseSchema)` to create a new message.
 */
export const UpdateVisionLocationResponseSchema: GenMessage<UpdateVisionLocationResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_location, 1);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionLocationResponse.Result
 */
export type UpdateVisionLocationResponse_Result = Message<"protos.vision.projects.v1.UpdateVisionLocationResponse.Result"> & {
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionLocationResponse.Result.
 * Use `create(UpdateVisionLocationResponse_ResultSchema)` to create a new message.
 */
export const UpdateVisionLocationResponse_ResultSchema: GenMessage<UpdateVisionLocationResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_location, 1, 0);

